import { StyledCustomCodeContainer } from './CustomCode.styled';
import { useMemoizedHTML } from '../../hooks/useMemoizedHTML';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const HTML_CONTENT_PLACEHOLDER = '<p>Hello world!</p>';
export const CSS_CONTENT_PLACEHOLDER = 'p { background-color: #fff; color: #FF0000 }';

// This block does not have external data props

/**
 * The `CustomCode` content block allows users to create a portion of the page using their
 * own custom HTML/CSS
 *
 * ----
 *
 * ! 🚨**[WARNING] The CustomCode Block does not handle sanitization. It is up to your
 * ! application to sanitize the user's custom code!**🚨
 *
 * ----
 */
export const CustomCode = ({
  contentHTML = HTML_CONTENT_PLACEHOLDER,
  contentCSS = CSS_CONTENT_PLACEHOLDER,
  parentLayoutInfo,
  fit,
  ...rest
}) => /*#__PURE__*/_jsx(StyledContentContainer, {
  fit: !!fit,
  parentLayoutInfo: parentLayoutInfo,
  children: /*#__PURE__*/_jsx(StyledCustomCodeContainer, {
    "data-id": "cp-custom-code",
    contentCSS: contentCSS,
    dangerouslySetInnerHTML: useMemoizedHTML(contentHTML),
    ...rest
  })
});